module.exports = {"350403001":"城关街道","350403002":"白沙街道","350403003":"富兴堡街道","350403004":"荆西街道","350403100":"莘口镇","350403101":"岩前镇","350403200":"城东乡","350403201":"中村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350403.json
// module id = 1090
// module chunks = 0